import React, { useEffect, useState } from "react";
import PropertyDetailsCard from "../offerWizard/PropertyDetailsCard";
import ProfileInfo from "@/components/bid/ProfileInfo";
import AccordianFormProfile from "@/components/bid/DemoAccordian";
import { getBidCMS } from "@/api/bid";
import { toast } from "react-toastify";

const ProfileVerification = ({ offerDetails ,setIdologyVerified }) => {
  const { offerPage } = offerDetails;
  const [cmsData, setCmsData] = useState(null);

  const onNavigate = (data) =>{
    if(data){
      toast.success("Your profile is verified successfully.");
      setIdologyVerified(true);
    }
  }
    useEffect(() => {
      getBidCMS("pages/bidWizard").then((response) => {
        setCmsData(response?.results?.[0]);
      });
    }, []);

  return (
    <div className="profile-verification-offer">
      <div className="offer-wizard">
        <PropertyDetailsCard
          propertyDetails={offerPage?.propertyDetails}
          listingOfferDetails={offerPage?.listingOfferPriceDetails}
        />
        <div className="profile-faq">
          {/* <ProfileInfo /> */}
        </div>
        <AccordianFormProfile onNavigate={onNavigate} isOfferPage={true} cmsData={cmsData}/>
      </div>
    </div>
  );
};

export default ProfileVerification;
